import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /address-book validation

const lockerSchema = yup.object({
  id: yup.string().required(),
  name: yup.string().required(),
  address: yup.object({
    country: yup.string().required(),
    postalCode: yup.string().required(),
  }),
});

const addressBookItemSchema = yup.object({
  id: yup.string().required(),
  contactName: yup.string().nullable().defined(),
  contactEmail: yup.string().nullable().defined(),
  contactPhone: yup.string().nullable().defined(),
  locker: lockerSchema.nullable().defined(),
  lockerId: yup.string().nullable().defined(),
  country: yup.string().nullable().defined(),
  countryCode: yup.string().nullable().defined(),
  city: yup.string().nullable().defined(),
  street: yup.string().nullable().defined(),
  streetNumber: yup.string().nullable().defined(),
  flatNo: yup.string().nullable().defined(),
  zip: yup.string().nullable().defined(),
});

const addressesResponseSchema = yup.object({
  items: yup.array().of(addressBookItemSchema),
});

export type TAddressBookItem = Asserts<typeof addressBookItemSchema>;

export type TAddressesResponse = Asserts<typeof addressesResponseSchema>;

const validateAddressesResponse = (response: any): TAddressesResponse => addressesResponseSchema.validateSync(response);

export default validateAddressesResponse;
